import React, { FC, ReactNode } from 'react'

import { styled } from '@linaria/react'

import { WithDataName } from 'common/types'
import { TextWaveUnderline } from 'components/designSystem/TextWaveUnderline/TextWaveUnderline'

export const ProfileTemplate: FC<
  {
    title: ReactNode | string
    body: ReactNode
  } & WithDataName
> = ({ title, body, ...rest }) => {
  return (
    <Parent>
      <TextWaveUnderline
        title={title}
        fontSize={16}
        data-name={rest['data-name']}
      />
      {body}
    </Parent>
  )
}

const Parent = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  gap: var(--spacing-12px);
  grid-gap: var(--spacing-12px);
`
